import React from 'react';
import { Table, Row, Col } from 'antd'

const SmallTable = ({
    columns = [
        {
            title: 'Name',
            dataIndex: 'name',
            key: 'name',
        },
        {
            title: 'Age',
            dataIndex: 'age',
            key: 'age',
        },
        {
            title: 'Address',
            dataIndex: 'address',
            key: 'address',
        },
    ],
    dataSource = [
        {
            key: '1',
            name: 'Mike',
            age: 32,
            address: '10 Downing Street',
        },
        {
            key: '2',
            name: 'John',
            age: 42,
            address: '10 Downing Street',
        },
    ]
}) => {
    const settingColumn = (columns) => {
        let ellipsisColumns = columns.map((value) => {
            return {
                ...value,
                ellipsis: true
            }
        })
        return ellipsisColumns
    }

    return (
        <Row>
            <Col span={24}>
                <Table
                    pagination={false}
                    sticky={true}
                    size='small'
                    dataSource={dataSource}
                    columns={settingColumn(columns)} />
            </Col>
        </Row>
    )
}

export default SmallTable
